export default __webpack_public_path__ + "static/media/IkonStack.ed6c95c7.svg";